const DEVICES = [
  { key: "iphone", name: "iPhone", image: "https://images.unsplash.com/photo-1746005718004-1f992c399428?w=400", desc: "Tous modèles" },
  { key: "ipad", name: "iPad", image: "https://images.unsplash.com/photo-1638273266965-843b01e02a5c?w=400", desc: "Pro, Air, Mini" },
  { key: "macbook", name: "MacBook", image: "https://images.unsplash.com/photo-1611186871348-b1ce696e52c9?w=400", desc: "Pro & Air" },
  { key: "imac", name: "iMac", image: "https://images.unsplash.com/photo-1560195307-95127677e806?w=400", desc: "Tous modèles" }
];

export const AppleDevicesGrid = () => (
  <section className="py-12 bg-white border-b">
    <div className="container-custom">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-slate-900">Nous réparons tous vos appareils Apple</h2>
      </div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
        {DEVICES.map((device) => (
          <div key={device.key} className="group relative rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300">
            <img
              src={device.image}
              alt={`Réparation ${device.name}`}
              className="w-full h-40 object-cover group-hover:scale-105 transition-transform duration-500"
              loading="lazy"
              width="400"
              height="160"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-slate-900/90 via-slate-900/40 to-transparent"></div>
            <div className="absolute bottom-0 left-0 right-0 p-4">
              <p className="text-white font-bold text-lg">{device.name}</p>
              <p className="text-white/70 text-sm">{device.desc}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);
